import { useMountEffect } from "@react-hookz/web";
import type { FC } from "react";
import { useNavigate } from "react-router";

const EmailAddressConfigurationPage: FC = () => {
  const navigate = useNavigate();

  useMountEffect(() => {
    void navigate("/manage/channels/email", { replace: true });
  });

  return <></>;
};

export default EmailAddressConfigurationPage;
